import React from "react"
import Layout from "../../components/Layout"
import "./index.scss"
import { Grid, Row, Column } from "carbon-components-react"

export default function index() {
  return (
    <Layout>
      <Grid style={{ paddingTop: 60, backgroundColor: "#f5f5f5" }} fullWidth>
        <Row>
          <Column lg={{ span: 13, offset: 3 }}>
            <h1 style={{ margin: "0 0 30px" }}>hello!</h1>
          </Column>
        </Row>
      </Grid>
    </Layout>
  )
}
